import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import I18n from 'translations/i18n'
import { Button, Spacer } from '@jisr-hr/design-system'
import { leaveExtensionsPost } from 'redux/requests/leaveExtensionsRequest/actionCreators'

import { required } from 'components/global/form/FormValidations'
import ModalTemplate from 'components/global/templates/ModalTemplate'
import AttachmentComponent from 'components/global/form/AttachmentComponent'
import { DatePicker, Select, Input } from 'components/global/molecules/redux-form'

class LeaveExtensionsRequest extends Component {
  submitRequestForm = (values) => {
    const { employeeId, requestId } = this.props

    this.props
      .leaveExtensionsPost(employeeId, {
        ...values,
        extended_request_id: requestId,
      })
      .then(() => {
        if (this.props.onDone) {
          this.props.onDone()
        }
        this.props.onCloseModal()
      })
  }

  render() {
    const { requestId, isOpen, onCloseModal } = this.props

    return (
      <ModalTemplate
        isOpen={isOpen}
        onCloseModal={onCloseModal}
        title={I18n.t('extensions_leave_request')}
      >
        <div style={{ minWidth: 600 }}>
          <RequestForm
            initialValues={{
              extended_request_id: requestId,
            }}
            onSubmit={this.submitRequestForm}
          />
        </div>
      </ModalTemplate>
    )
  }
}

let RequestForm = ({ leaveTypes, handleSubmit, fetching, change }) => (
  <form onSubmit={handleSubmit}>
    <div className="row">
      <div className="col">
        <Field
          name="leave_type_id"
          component={Select}
          valueKey="id"
          label={I18n.t('leave_type')}
          labelKey="name"
          options={leaveTypes}
          validate={[required]}
          handleValue
          version="v1"
        />
      </div>
      <div className="col">
        <Field
          name="return_date"
          label="return_date"
          component={DatePicker}
          placeholder={I18n.t('assets_return_date')}
        />
      </div>
    </div>
    <Spacer height="18px" />
    <div className="row">
      <div className="col mb-4">
        <Field
          name="reason"
          as="textarea"
          component={Input}
          rows={5}
          label="reason"
        />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <Field
          name="attachment"
          component={AttachmentComponent}
          label="upload_your_attachment"
          onDone={(file) => change('attachment_file_name', file.file_file_name)}
        />
      </div>
    </div>
    <div>
      <Button
        label={I18n.t('apply')}
        type="submit"
        size="medium"
        variant="primary"
        disabled={fetching}
      />
    </div>
  </form>
)

const selector = formValueSelector('LeaveExtensionsRequestForm')

function mapStateToProps(store) {
  const { employeeLeaveTypes, leaveExtensionsRequest } = store
  return {
    leaveTypes: employeeLeaveTypes.leave_types,
    fileName: selector(store, 'file_file_name') || I18n.t('upload_your_attachment'),
    fetching: leaveExtensionsRequest.fetching,
  }
}

RequestForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  leaveTypes: PropTypes.arrayOf(PropTypes.shape()),
  fetching: PropTypes.bool,
  change: PropTypes.func.isRequired,
}

const idPropTypes = [PropTypes.string, PropTypes.number]

LeaveExtensionsRequest.propTypes = {
  leaveExtensionsPost: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onDone: PropTypes.func,
  isOpen: PropTypes.bool,
  employeeId: PropTypes.oneOfType(idPropTypes),
  requestId: PropTypes.oneOfType(idPropTypes),
}

RequestForm = connect(mapStateToProps, null)(RequestForm)

RequestForm = reduxForm({
  form: 'LeaveExtensionsRequestForm',
  enableReinitialize: true,
})(RequestForm)

export default connect(null, {
  leaveExtensionsPost,
})(LeaveExtensionsRequest)
